export const tableMap={
    "toName": {
        "account": "Account",
        "user": "User",
        "account_membership": "AccountMembership",
        "guardian": "Guardian",
        "project": "Project",
        "account_invite": "AccountInvite",
        "form_submission": "FormSubmission"
    },
    "toTable": {
        "Account": "account",
        "Account_insert": "account",
        "User": "user",
        "User_insert": "user",
        "AccountMembership": "account_membership",
        "AccountMembership_insert": "account_membership",
        "Guardian": "guardian",
        "Guardian_insert": "guardian",
        "Project": "project",
        "Project_insert": "project",
        "AccountInvite": "account_invite",
        "AccountInvite_insert": "account_invite",
        "FormSubmission": "form_submission",
        "FormSubmission_insert": "form_submission"
    }
}